import React, { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { PricingPlan } from '../models/pricing-plan';
import { useOrganization } from './organization';
import { handleApiError } from '../api-client/error_handler';
import axios from 'axios';

interface PricingPlansContextType {
  pricingPlans: PricingPlan[];
  loading: boolean;
}

const PricingPlansContext = createContext<PricingPlansContextType | undefined>(undefined);

export const PricingPlansProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [pricingPlans, setPricingPlans] = useState<PricingPlan[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { organization } = useOrganization();

  const fetchPricingPlans = async () => {
    try {
      const { data } = await axios.get(process.env.REACT_APP_API_BASE_URL + '/pricing-plans');
      setPricingPlans(data.pricing_plans ?? []);
    } catch (error: unknown) {
      toast.error(handleApiError(error));
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    if (!organization) return;
    fetchPricingPlans();
  }, [organization]);

  return (
    <PricingPlansContext.Provider value={{ pricingPlans, loading }}>
      {children}
    </PricingPlansContext.Provider>
  );
};

export const usePricingPlans = () => {
  const context = useContext(PricingPlansContext);
  if (!context) {
    throw new Error('usePricingPlans must be used within a PricingPlansProvider');
  }
  return context;
};
